import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.658 4.004a.7.7 0 0 1 .988 0l6.148 6.122a.7.7 0 0 1 0 .992L13.08 18.8h7.22a.7.7 0 1 1 0 1.4H8.311a.7.7 0 0 1-.494-.204l-4.61-4.592a.7.7 0 0 1 0-.992zM11.096 18.8l1.449-1.443-5.156-5.134-2.697 2.685L8.6 18.8zm-2.715-7.565 5.156 5.134 5.771-5.747-5.156-5.134z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=EraserIcon24.js.map